
import { Stack } from 'ui/stack';

import Badge from 'components/partials/badge/badge';

import Icons from 'assets/icons';

import type { InsightActivityUser } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/hooks/use-user-activity';

interface UserActivityCellArgs {
  row: { original: InsightActivityUser };
}

interface UserActivityColumnDef {
  id: string;
  accessorKey?: string;
  header: () => React.JSX.Element;
  cell: (args: UserActivityCellArgs) => React.ReactNode;
  headerClassName?: string;
  className?: string;
  enableSorting?: boolean;
}

export const getUserActivityTableSettings = (): UserActivityColumnDef[] => [
  {
    id: 'name',
    accessorKey: 'firstName',
    header: () => (
      <span className="text-xs font-semibold text-navy-500">USER NAME</span>
    ),
    cell: ({
      row: {
        original: { firstName, lastName },
      },
    }) => (
      <span className="font-semibold text-gray-700">{`${firstName} ${lastName}`}</span>
    ),
    headerClassName:
      'border-r-2 border-white pl-4 h-12 rounded-tl-md rounded-bl-md',
    className: 'pl-4 py-3 w-[30%]',
    enableSorting: false,
  },
  {
    id: 'jobTitle',
    accessorKey: 'jobTitle',
    header: () => (
      <span className="text-xs font-semibold text-navy-500">JOB TITLE</span>
    ),
    cell: ({
      row: {
        original: { jobTitle },
      },
    }) => <span className="text-gray-700">{jobTitle}</span>,
    headerClassName: 'h-12 text-left border-r-2 border-white',
    className: 'pl-4 py-3 text-left w-[25%]',
    enableSorting: false,
  },
  {
    id: 'usersActivity',
    header: () => (
      <span className="text-xs font-semibold text-navy-500">
        USERS ACTIVITY
      </span>
    ),
    cell: ({
      row: {
        original: { viewed, downloaded },
      },
    }) => (
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
        {viewed && (
          <Badge
            text="Viewed"
            icon={<Icons.Eye className="size-3.5" />}
            variant="primary"
          />
        )}
        {downloaded && (
          <Badge
            text="Downloaded"
            icon={<Icons.Download className="size-3.5" />}
            variant="secondary"
          />
        )}
      </Stack>
    ),
    headerClassName: 'h-12 text-left rounded-tr-md rounded-br-md',
    className: 'pl-4 py-3 text-left',
    enableSorting: false,
  },
];
